import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import TesoreriaService from "../../services/tesoreriaService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";


export const getUsuariosOspedycDirecto = () => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const result = await TesoreriaService.getUsuariosOspeDirecto();
            const body = await result.json();
            if (result.ok) {
                dispatch({
                    type: types.usuariosOspeDirectoSuccess,
                    payload: body,
                });
            } else {
                throw body;
            }
            dispatch(finishSpinner());
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al obtener los usuarios",
                "Ha ocurrido un error. Intente nuevamente"
            );
        }
    };
};

export const buscarUsuariosOspeDirecto = (text) => (dispatch) => {
    dispatch({
        type: types.usuariosOspeDirectoBuscar,
        payload: text
    });
}

export const enviarUsuarioVentanilla = (idEfector, email, usuarioVentanilla, passwordVentanilla) => {
    debugger
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const response = await fetchConToken(
          `Tesoreria/generarMailEnvioUsuario/${idEfector}/${email}/${usuarioVentanilla}/${passwordVentanilla}`,
        );
        const body = await response.json();
        if (response.ok) {
          dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (err) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          err,
          "Ocurrio un error en el envío de mail",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };